import Wahanda from 'common/wahanda';

import { DISABLE_REASON, DisableReason } from './employeeEditPolicy';

type TooltipLang = Record<string, string>;

const TOOLTIP_LANG_KEYS: Record<DisableReason, string> = {
  [DISABLE_REASON.NO_ADD_THERAPISTS]: 'noAddTherapists',
  [DISABLE_REASON.NO_EDIT_USER_PERMISSIONS]: 'noEditUserPermissions',
  [DISABLE_REASON.SELF_EDIT_FORBIDDEN]: 'selfEditForbidden',
  [DISABLE_REASON.SUPPLIER_BOUND]: 'supplierBound',
  [DISABLE_REASON.TARGET_ADMIN_IMMUTABLE]: 'targetAdminImmutable',
  [DISABLE_REASON.NON_ADMIN_CANNOT_EDIT_ADMIN]: 'nonAdminCannotEditAdmin',
  [DISABLE_REASON.SELF_DEACTIVATE]: 'selfDeactivate',
  [DISABLE_REASON.PERMISSION_NOT_HELD_BY_ACTOR]: 'permissionNotHeldByActor',
  [DISABLE_REASON.PERMISSION_IMPLIED]: 'permissionImplied',
  [DISABLE_REASON.CANNOT_GRANT_FULL_PRESET_ROLE]: 'cannotGrantFullPresetRole',
  [DISABLE_REASON.EMAIL_REQUIRED]: 'emailRequired',
};

const getTooltipLang = (): TooltipLang =>
  Wahanda.lang.settings.employees.employee.permissions.tooltips ?? {};

export const getDisableReasonTooltip = (reason: DisableReason): string => {
  const langKey = TOOLTIP_LANG_KEYS[reason];
  return getTooltipLang()[langKey] ?? '';
};
